import { type SearchExamCenterLocationsUsageQuery } from '@exam-center/graphql';
import { dayjs } from '@shared/utils';

import { type AdminExamCenterLocationUsageItem } from '../../components/';

type ExamCenterLocationUsageDataItem =
  SearchExamCenterLocationsUsageQuery['ecSearchExamCenterLocationsUsage']['examCenterLocations'][number];

export function mapExamCenterLocationUsageItem(
  data: ExamCenterLocationUsageDataItem,
): AdminExamCenterLocationUsageItem {
  const approvedAt = dayjs(data.approvedAt ?? null);
  const requestedAt = dayjs(data.examRoomRequestInfo?.requestedAt ?? null);
  const latestVerdicts = [...(data.examRoomRequestInfo?.examLocationRequestVerdicts ?? [])]
    .filter((verdict) => dayjs(verdict.requestedAt ?? null).isSame(requestedAt))
    .sort((a, b) => (dayjs(a.submittedAt ?? null).isBefore(dayjs(b.submittedAt ?? null)) ? -1 : 1));

  return {
    id: data.id,
    roomId: data.refId,
    examCenterCode: data.examCenterCode,
    requestedAt: requestedAt.toDate(),
    approvedAt: approvedAt.toDate(),
    approvedBy:
      latestVerdicts?.map(
        (verdict) => `${verdict.updatedUser?.firstname} ${verdict.updatedUser?.lastname}`,
      ) ?? [],
  };
}
